import { MockPath } from '@library/common/http/mock-path.mock';

import { randomArray } from '@library/common/functions';
import { MockInvoice, MockInvoiceHeader } from './invoice.mock';

export const InvoicesRoutes: MockPath<unknown>[] = [
   { path: 'invoice/list', verb: 'GET', collection: () => randomArray( MockInvoiceHeader ) },
   { path: 'invoice.*', verb: 'GET', collection: () => randomArray( MockInvoice, 50 ) },
];
